import React from 'react';
import './Input.scss';

const Input = props => {   
  
  return (
    <div className='input-main' style={props.mainStyle} > 
      {!props.search && <label style={{color: 'black'}} htmlFor={props.id}>{props.label}</label>} 
      <input
        id={props.id}
        name={props.name}
        type={props.type}
        placeholder={props.placeholder}
        onChange={props.onChange}
        value={props.value || ''}
        style={props.style}
        autoComplete={props.autoComplete}
      />
    </div>
  );
};


export default Input;
